<template>
  <b-modal
    id="welcome-modal"
    v-model="showModal"
    centered
    hide-header
    hide-footer
    :no-close-on-backdrop="!isClosable"
    :no-close-on-esc="!isClosable"
    modal-class="welcome-modal-wrapper"
    body-class="welcome-modal-body"
    @hide="onModalHide"
  >
    <div class="text-center p-4">
      <button 
        v-if="isClosable" 
        type="button" 
        class="close-modal-btn" 
        @click="cancelModal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h3 class="mb-4">Welcome to Protopia</h3>
      <b-form-group label="Select your community:" label-for="modal-dropdown" class="mt-3">
        <b-form-select
          id="modal-dropdown"
          v-model="selectedOption"
          @change="handleSelection"
        >
          <option value="" disabled selected hidden>Choose a community</option>
          <option v-for="community in communities" :key="community.communityId" :value="community.communityId">
            {{ community.communityName }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-button variant="primary" @click="closeModal" class="mt-3" :disabled="!selectedOption">
        Save Community
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {
  name: 'WelcomeModal',
  data() {
    return {
      showModal: false,
      selectedOption: '',
      communities: [],
      isClosable: FinalizationRegistry
    }
  },
  mounted() {
    const savedOption = localStorage.getItem('user_modal_option')
    if (savedOption) {
      this.selectedOption = savedOption
    }
    
    this.getCommunities();

    this.$root.$on('show-welcome-modal', (data) => {
      let communityId = data;
      
      if (data && typeof data === 'object') {
        communityId = data.selectedCommunity;
        
        this.isClosable = true;
        // Use the updated community list from DefaultContainer (has real names)
        if (data.communityList && data.communityList.length > 0) {
          console.log('Modal received community list from DefaultContainer:', data.communityList);
          // Create new array with all items to ensure reactivity
          this.communities = data.communityList.map(c => ({ 
            communityId: c.communityId, 
            communityName: c.communityName 
          }));
          console.log('Modal communities after update:', this.communities);
        }
      } else {
        // This is from loginuser must select a community
        this.isClosable = false;
      }
      
      // Prioritize passed communityId, otherwise fallback to localStorage
      if (communityId && communityId !== 'all') {
          this.selectedOption = communityId;
      } else {
          const savedOption = localStorage.getItem('user_modal_option')
          if (savedOption) {
            this.selectedOption = savedOption
          }
      }
      
      this.showModal = true
      this.$root.$emit('toggle-blur', true);
    })
    
    this.$root.$on('community-list-updated', (updatedList) => {
      if (updatedList && updatedList.length > 0) {

        updatedList.forEach(updated => {
          const index = this.communities.findIndex(c => c.communityId === updated.communityId);
          if (index !== -1) {
            this.$set(this.communities, index, { ...this.communities[index], communityName: updated.communityName });
          }
        });
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('show-welcome-modal')
    this.$root.$off('community-list-updated')
  },
  methods: {
    async getCommunities() {
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { 'x-access-token': token } : {};
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/tenants`, { headers });
        
        if (response.data && response.data.data) {
            let allTenants = response.data.data
                .map(t => ({ communityId: t.communityId, communityName: t.communityName }))
                .sort((a, b) => a.communityName.localeCompare(b.communityName));
            
            // Filter based on user role and communities
            const authUser = JSON.parse(localStorage.getItem('authUser'));
            if (authUser) {
                const role = authUser.role ? authUser.role.toLowerCase() : '';
                
                if (role === 'superadmin') {
                    // SuperAdmin sees all communities
                    this.communities = allTenants;
                } else if (authUser.communities && authUser.communities.length > 0) {
                    // Admin sees only their assigned communities
                    this.communities = allTenants.filter(t => authUser.communities.includes(t.communityId));
                } else {
                    // Fallback or no communities assigned
                    this.communities = [];
                }
            } else {
                // Fallback if no user found (shouldn't happen if logged in)
                this.communities = [];
            }
            
            this.applyCachedNames();

            // Auto-select logic if no option is saved
            if (!this.selectedOption) {
                if (this.communities.length === 1) {
                    this.selectedOption = this.communities[0].communityId;
                    this.closeModal();
                } else if (this.communities.length > 1) {
                    // This is logi user must select a community
                    this.isClosable = false;
                    this.showModal = true;
                    this.$root.$emit('toggle-blur', true);
                }
            }
        } else {
            console.log("No data found in response:", response);
        }
      } catch (error) {
        console.error("Error fetching tenants:", error);
      }
    },
    closeModal() {
      if (this.selectedOption) {
        console.log('Selected option:', this.selectedOption)
        
        const selectedCommunity = this.communities.find(c => c.communityId === this.selectedOption);
        const communityName = selectedCommunity ? selectedCommunity.communityName : '';
        
        localStorage.setItem('user_modal_option', this.selectedOption);
        localStorage.setItem('community_id', this.selectedOption);
        if (communityName) {
          localStorage.setItem('community_name', communityName);
        }
        
        // Emit event to root to notify DefaultContainer
        this.$root.$emit('community-selected', this.selectedOption);
        this.$root.$emit('toggle-blur', false);

        this.showModal = false
      }
    },
    handleSelection(value) {
      console.log('User selected:', value)
    },
    cancelModal() {
      if (this.isClosable) {
        this.showModal = false;
        this.$root.$emit('toggle-blur', false);
      }
    },
    onModalHide(event) {
      if (!this.isClosable) {
        if (event.trigger === 'backdrop' || event.trigger === 'esc') {
          event.preventDefault();
        }
      } else {
        this.$root.$emit('toggle-blur', false);
      }
    },
    applyCachedNames() {
      try {
        const cache = JSON.parse(localStorage.getItem('community_names_cache') || '{}');
        this.communities.forEach((community, index) => {
          if (cache[community.communityId]) {
            this.communities[index].communityName = cache[community.communityId];
          }
        });
      } catch (e) {
        console.error('Error applying cached names:', e);
      }
    }
  }
}
</script>

<style scoped>
/* Estilos para el modal moderno */
.welcome-modal-body {
  border-radius: 12px;
  padding: 0;
}

::v-deep .welcome-modal-wrapper .modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: modalFadeIn 0.3s ease-out;
  position: relative;
}

/* Close button styles */
.close-modal-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 28px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  z-index: 10;
  transition: all 0.2s ease;
}

.close-modal-btn:hover {
  color: #ffffff;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  transform: none;
}

.close-modal-btn:focus {
  outline: none;
  color: #ffffff;
}

.close-modal-btn:focus-visible {
  outline: 2px dotted rgba(255, 255, 255, 0.8);
  outline-offset: 4px;
  color: #ffffff;
}

/* Animaciones suaves */
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
